import { render, staticRenderFns } from "./store-group-attributes-dialog.vue?vue&type=template&id=c4a7e3f2&scoped=true"
import script from "./store-group-attributes-dialog.vue?vue&type=script&lang=js"
export * from "./store-group-attributes-dialog.vue?vue&type=script&lang=js"
import style0 from "./store-group-attributes-dialog.vue?vue&type=style&index=0&id=c4a7e3f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a7e3f2",
  null
  
)

export default component.exports